import { useCallback, useEffect, useState } from "react"

import toastMessages from "stores/toastMessages"
import { ISelectOption } from "components/Select/Select"
import { FilterCategory, Purpose } from "config/constants"
import AssetService from "services/AssetService"
import { getPurposeLabel,  } from "utils/utils"

export default function useReservationPurposeOptions(currentFilterCategory: FilterCategory) {
    const [options, setOptions] = useState<ISelectOption<Purpose>[] | undefined>()
    const fetchOptions = useCallback(async () => {
        try {
            const purposes = await AssetService.getReservationPurposes()
            if (!purposes) return
            setOptions(purposes.list.map(p => ({ label: getPurposeLabel(p), value: p })))
        } catch (e) {
            toastMessages.showSystemError()
        }
    }, [])

    useEffect(() => {
        if (currentFilterCategory !== FilterCategory.reservationPurpose || options) return
        fetchOptions()
    }, [fetchOptions, currentFilterCategory, options])

    return {
        reservationPurposeOptions: options,
    }

}
